'use strict';

const _ = require('underscore');
const simpleStorage = require('simplestorage.js');
const Marionette = require('backbone.marionette');
const $ = require('jquery');
const Radio = require('backbone.radio');
const { default: i18n } = require('i18next');
const WarningView = require('./components/warningView');
const showLanguagesView = require('./components/languagesView');
const ErrorView = require('./components/msgBoxView');

const navChannel = Radio.channel('controller');
const Constants = require('../Constants');
const template = require('../templates/username.hbs');
const utils = require('../utils');
const Language = require('../Language');

const ajaxOptions = {
  url:    `${NETOP_CONFIG.SECURE_API}/startLogin`,
  method: 'POST',
};

const UserNameView = Marionette.ItemView.extend({
  template,
  tagName: 'div',
  ui:      {
    language:              '.language-container',
    username_label:        '#username_label',
    username:              '#username',
    form_group:            '.form-group',
    error:                 '.error',
    input_error:           '.input-error',
    sub_message:           '.sub-message',
    sub_message_container: '.sub-message-container',
  },
  events: {
    'input @ui.username': 'onFocusUsername',
    'focus @ui.username': 'onFocusUsername',
    'blur @ui.username':  'onBlurUsername',
    'submit form':        'handleSubmit',
  },

  initialize: function fInitialize(args) {
    this.model = args.model;
  },

  onFocusUsername: function fOnFocusUsername() {
  },

  onBlurUsername: function fOnFocusUsername() {
  },

  handleSubmit: function fHandleSubmit(event) {
    event.preventDefault();

    const username = this.ui.username.val();
    if (!username) {
      this.warningView.show(i18n.t('common:mandatory-field'));
      this.errorView.hide();
      this.ui.username.parent().addClass('has-error');
      this.ui.username.focus();
      return;
    }

    this.model.set({
      username,
    });

    $.ajax({
      url:    ajaxOptions.url,
      method: ajaxOptions.method,
      data:   {
        username:      this.model.get('username'),
        nativeClient:  simpleStorage.get(Constants.nativeClient) ? 1 : 0,
        clientVersion: simpleStorage.get(Constants.nativeClientVersion) || '',
        authorize:     this.model.get('authorize'),
        inviteKey:     this.model.get('inviteKey') || '',
        language:      Language.currentLanguage.name,
      },
    })
      .done((body) => {
        if (body.nextStep === 'ERROR') {
          this.model.set(_.extend({}, body, (body.options || {})));
          navChannel.trigger(this.model.get('nextStep'));
          return;
        }

        this.model.set({
          loginSessionId: body.loginSessionId,
          nextStep:       body.nextStep,
          options:        body.options || {},
        });
        const options = body.nextStep === 'AUTH_PORTAL' ? {
          captcha:        !!body.captcha,
          captchaEnabled: !!body.captchaEnabled,
        } : null;
        if (!options || !options.captchaEnabled) {
          $(document.body).addClass('captcha-disabled');
        }
        navChannel.trigger(this.model.get('nextStep'), options);
      })
      .fail((error) => {
        if (console) {
          if (error.responseJSON && error.responseJSON.code && error.responseJSON.traceId) {
            console.error('Error', error.responseJSON.code, error.responseJSON.traceId);
          } else {
            console.error('Error happened', error);
          }
        }
        this.errorView.show(i18n.t('common:unknown-error'));
        this.warningView.hide();
      });
  },

  onChangeLanguage: function fChangeLang() {
    const $middle = $('#middle');
    $middle.css({ height: `${$middle.outerHeight()}px` });
    const username = this.ui.username.val();
    this.render();
    this.ui.username.val(username);
    setTimeout(() => $middle.css({ height: '' }), 100);
  },

  onRender: function fOnRender() {
    this.errorView = new ErrorView({
      el: this.ui.error,
    });
    this.warningView = new WarningView({
      el: this.ui.input_error,
    });

    showLanguagesView({ parent: this });

    const errCode = this.model.get('error');

    if (errCode) {
      if (errCode >= 30000 && errCode <= 30099) {
        this.errorView.hide();
        this.warningView.show(utils.mapErrorCodeToMessage(errCode));
      } else {
        this.warningView.hide();
        this.errorView.show(utils.mapErrorCodeToMessage(errCode));
      }
      if (parseInt(errCode, 10) === 1205) {
        if (simpleStorage.get(Constants.nativeClient)) {
          // Desktop guest (older CEF): the portal purchase page fails to load
          // there, so render our own ES5 purchase page instead. Same 2s delay
          // as the browser redirect below, so the user sees the expiry message
          // first (and it's deferred, so we don't re-enter the region mid-render).
          setTimeout(() => {
            navChannel.trigger('PURCHASE_EXPIRED');
          }, 2000);
        } else {
          // Browser: redirect to the portal purchase page as before.
          const portalBase = NETOP_CONFIG.PORTAL_FRONTEND;
          const purchasePage = [portalBase, NETOP_CONFIG.PURCHASE_PATH]
            .join(portalBase.endsWith('/') ? '' : '/');
          setTimeout(() => {
            window.location.href = purchasePage;
          }, 2000);
        }
      }
    }
    setTimeout(() => {
      // sub_message may contain some temporary messages; show them only on desktop if needed
      if (!$(document.body).hasClass('native-client')) {
        const displayMessage = true;
        if (displayMessage) {
          this.ui.sub_message.removeClass('hidden');
        } else {
          // provide some space if we dont display a message here
          this.ui.sub_message_container.addClass('sub-message-container-desktop');
        }
      }
      this.ui.username.focus();
    }, 1); // Doesn't work without timeout, cba with proper fix
  },
});

module.exports = UserNameView;
